import React, { useState, useCallback } from 'react';
import { Dropdown as AntdDropdown } from 'antd';
import { LANGUAGE_ABBREVIATIONS } from 'src/constants';
import { useTranslation } from 'react-i18next';
import { RuIcon } from '../icons/ru';
import { EnIcon } from '../icons/en';
import { LtIcon } from '../icons/lt';
import styles from './styles.module.less';

const LIST = [
  {
    id: LANGUAGE_ABBREVIATIONS.EN,
    icon: EnIcon,
    title: 'EN',
  },
  {
    id: LANGUAGE_ABBREVIATIONS.LT,
    icon: LtIcon,
    title: 'LT',
  },
  {
    id: LANGUAGE_ABBREVIATIONS.RU,
    icon: RuIcon,
    title: 'RU',
  },
];

const Item = ({
  icon: Icon,
  title,
  id,
  onClick,
}) => {
  const handleClick = useCallback(() => {
    if (onClick) {
      onClick(id);
    }
  }, [id]);
  return (
    <div
      tabIndex={0}
      role="button"
      className={styles.item}
      onClick={handleClick}
    >
      <span className={styles.iconWrap}>
        <Icon className={styles.icon} />
      </span>
      <span className={styles.lang}>
        {title}
      </span>
    </div>
  );
};

export function Language() {
  const { i18n } = useTranslation();
  const [currentId, setCurrent] = useState(i18n.language);

  const changeLang = (lng) => {
    setCurrent(lng);
    i18n.changeLanguage(lng);
  };

  const handleChange = useCallback((id) => {
    changeLang(id);
  }, [i18n]);

  const list = LIST.filter((item) => item.id !== currentId);
  const current = LIST.find((item) => item.id === currentId);
  const { icon: Icon } = current;

  return (
    <AntdDropdown
      placement="bottomCenter"
      trigger={['click', 'hover']}
      overlay={(
        <div className={styles.menu}>
          {list.map(({ id, title, icon }) => (
            <Item
              key={id}
              title={title}
              icon={icon}
              id={id}
              onClick={handleChange}
            />
          ))}
        </div>
      )}
    >
      <div
        tabIndex={0}
        role="button"
        className={styles.option}
      >
        <span className={styles.iconWrap}>
          <Icon className={styles.icon} />
        </span>
        <span className={styles.lang}>
          {current.title}
        </span>
      </div>
    </AntdDropdown>
  );
}
